/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
// import { Accordion, Card } from "react-bootstrap";
import _ from "lodash";
import Pagination from "react-js-pagination";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getMyTeam, getMyTeamExport } from "actions";
// import "components/invoices/invoice.css";
import MembersTable from "components/myteam/MembersTable";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { api } from "api";
import GuideMembersTable from "./GuideMemberTable";
import './guide.css';
import Spinner from 'react-bootstrap/Spinner';

class GuideCenter extends Component {
    state = {
        teamFetched: false,
        filteredTeamData: [],
        filterTerm: "",
        error: null,
        activePage: 1,
        fullData: [],
        title: "",
        isDataLoading: true
    };

    settings = {
        itemsPerPage: 10,
    };

    async componentDidMount() {

        //  this.fetchMyTeam();
        await this.fetchSize();
        this.setState({
            title: this.state.fullData[0].title
        })
        // this.props.onProcessEnd();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    fetchSize = async () => {
        this.props.onProcessBegin();
        try {
            await api.get(`/api/guide/get-guide-center`).then((response) => {
                this.setState({
                    teamFetched: true,
                    fullData: response.data.data.items,
                    filteredTeamData: response.data.data.items
                });
            })
                .catch((err) => {
                    console.error(err);
                }).finally(() => {
                })
        } catch { }
        this.setState({ isDataLoading: false });
    };


    // componentDidUpdate = (prevProps, prevState) => {
    //     if (this.state.filterTerm !== prevState.filterTerm) {
    //         this.setState({
    //             filteredTeamData: this.state.fullData.filter((member) => {
    //                 return member.mainStep &&
    //                     member.mainStep.toLowerCase()
    //                         .includes(this.state.filterTerm.toLowerCase());
    //             }),
    //         });
    //     }
    // };

    // onBegin = () => {
    //     this.props.onProcessBegin();
    // };

    // onError = (err) => {
    //     console.log(err);
    //     this.props.onProcessEnd();
    // };

    // onSuccess = (res) => {
    //     this.props.onProcessEnd();
    //     this.setState({
    //         teamFetched: true,
    //         filteredTeamData: this.props.myTeam.items,
    //     });
    // };

    // fetchMyTeam = () => {
    //     this.props.getMyTeam(this.onBegin, this.onSuccess, this.onError);
    // };

    handlePageChange = (pageNum) => {
        this.setState({ activePage: pageNum });
    };

    handleFetch = () => {
        this.setState({ teamFetched: false });
        this.fetchMyTeam();
    };

    handleFilter = (e) => {
        this.setState({ filterTerm: e.target.value });
    };

    handleExport = async () => {
        try {
            await api
                .get(`/api/guide/get-guide-center-export`)
                .then((res) => {
                    const fileName = "Kılavuz.xlsx";
                    this.onExportSuccess(res.data, fileName);
                })
                .catch((e) => {
                });
        } catch { }
    };


    onExportSuccess = (res, fname) => {
        debugger;
        const url = window.URL.createObjectURL(new Blob([res.data.items]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
    };

    renderTableToolbar = () => {
        return (
            <div className="row align-items-center py-3 eduTitleArea">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 tableSearchArea">
                            <div className="inner-addon right-addon">
                                <span className="iconmford fo-icon-search"></span>
                                <input
                                    type="text"
                                    name="tableSearch"
                                    id="tableSearch"
                                    className="form-control"
                                    placeholder={i18n.t("10053")}
                                    onChange={(e) => this.handleFilter(e)}
                                    value={this.state.filterTerm}
                                />
                            </div>
                        </div>

                        {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                <button className="export-button" onClick={this.handleExport}>
                                    <Trans desc="Dışa Aktar">10113</Trans>
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    };

    renderPager = () => {
        return (
            <div
                style={{
                    display: "grid",
                    justifyContent: "right",
                    marginRight: "20px",
                }}
            >
                <Pagination
                    hideFirstLastPages={true}
                    prevPageText="Önceki"
                    nextPageText="Sonraki"
                    hideDisabled={true}
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.settings.itemsPerPage}
                    totalItemsCount={this.state.filteredTeamData.length}
                    onChange={(e) => this.handlePageChange(e)}
                    itemClass="page-item"
                    linkClass="page-link"
                />
            </div>
        );
    };

    HtmlViewer(htmlContent) {
        return (
            <div
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
        );
    }

    renderKlavuz = () => {
        return (
            <div>




                <div className="blockGuideHeader">
                    <h4>{this.state.title}</h4>
                </div>


                {this.state.fullData.length > 0 ? (


                    this.state.fullData
                        .filter((c) => c.subItem === null)
                        .map((item, index) =>
                            <div key={index}>

                                {item.file ? <div className="pageGuide">
                                    {
                                        item.documentdirection === 0 ?
                                            <>
                                                <div className="blockGuide">
                                                    <h4>{item.mainStep}</h4>
                                                    <h5>{item.subStep}</h5>
                                                    {this.HtmlViewer(item.description)}
                                                </div>

                                                <div className="blockGuide">
                                                    {item.file ? <img src={`data:${item.file?.mimetype};base64,${item.file?.file}`} name={item.file?.filename} style={{ width: "-webkit-fill-available" }} /> : null}
                                                </div>
                                            </> :
                                            <>
                                                <div className="blockGuide">
                                                    {item.file ? <img src={`data:${item.file?.mimetype};base64,${item.file?.file}`} name={item.file?.filename} style={{ width: "-webkit-fill-available" }} /> : null}
                                                </div>

                                                <div className="blockGuide">
                                                    <h4>{item.mainStep}</h4>
                                                    <h5>{item.subStep}</h5>
                                                    {this.HtmlViewer(item.description)}
                                                </div>
                                            </>
                                    }
                                </div> :
                                    <div style={{
                                        "background": "white",
                                        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                                        "display": " grid",
                                        padding: "20px",
                                        position: "relative"
                                    }}>
                                        <div className="blockGuide">
                                            <h4>{item.mainStep}</h4>
                                            <h5>{item.subStep}</h5>
                                            {this.HtmlViewer(item.description)}
                                        </div>
                                    </div>
                                }


                                {this.state.fullData
                                    .filter((a) => a.subItem === item.guideCenterId)
                                    .map((itema, indexa) =>
                                        <div key={indexa}>





                                            {itema.file ? <div className="pageGuide">
                                                {
                                                    itema.documentdirection === 0 ?
                                                        <>
                                                            <div className="blockGuideEmpty">
                                                                <h4>{itema.mainStep}</h4>
                                                                <h5>{itema.subStep}</h5>
                                                                {this.HtmlViewer(itema.description)}
                                                            </div>

                                                            <div className="blockGuideEmpty">
                                                                {itema.file ? <img src={`data:${itema.file?.mimetype};base64,${itema.file?.file}`} name={itema.file?.filename} style={{ width: "-webkit-fill-available" }} /> : null}
                                                            </div>
                                                        </> :
                                                        <>
                                                            <div className="blockGuideEmpty">
                                                                {itema.file ? <img src={`data:${itema.file?.mimetype};base64,${itema.file?.file}`} name={itema.file?.filename} style={{ width: "-webkit-fill-available" }} /> : null}
                                                            </div>

                                                            <div className="blockGuideEmpty">
                                                                <h4>{itema.mainStep}</h4>
                                                                <h5>{itema.subStep}</h5>
                                                                {this.HtmlViewer(itema.description)}
                                                            </div>
                                                        </>
                                                }
                                            </div> :
                                                <div style={{
                                                    "background": "white",
                                                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                                                    "display": " grid",
                                                    padding: "20px",
                                                    position: "relative"
                                                }}>
                                                    <div className="blockGuideEmpty">
                                                        <h4>{itema.mainStep}</h4>
                                                        <h5>{itema.subStep}</h5>
                                                        {this.HtmlViewer(itema.description)}
                                                    </div>
                                                </div>
                                            }




                                            {/* {itema.file ? <div className="pageGuide">
                                                <div className="blockGuideEmpty">
                                                    <h4>{itema.mainStep}</h4>
                                                    <h5>{itema.subStep}</h5>
                                                    {this.HtmlViewer(itema.description)}
                                                </div>

                                                <div className="blockGuideEmpty">
                                                    {itema.file ? <img src={`data:${itema.file?.mimetype};base64,${itema.file?.file}`} name={itema.file?.filename} style={{ width: "-webkit-fill-available" }} /> : null}
                                                </div>

                                            </div> :
                                                <div style={{
                                                    "background": "white",
                                                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                                                    "display": " grid",
                                                    padding: "20px",
                                                    position: "relative"
                                                }}>
                                                    <div className="blockGuideEmpty">
                                                        <h4>{itema.mainStep}</h4>
                                                        <h5>{itema.subStep}</h5>
                                                        {this.HtmlViewer(itema.description)}
                                                    </div>
                                                </div>
                                            } */}


                                        </div>)}
                                <div className="pageGuide">
                                    <div className="page-numberGuide">Sayfa {index + 1}</div></div>
                            </div>)
                ) : (
                    <></>
                    // <div className="blockGuideHeader">
                    //     <h4>Not Found</h4>
                    // </div>
                )}
            </div>
        );
    };

    Load() {
        return (
            <>

                <div className="blockGuideHeader">

                    <Spinner animation="grow" role="status" variant="primary" style={{ width: "60px", height: "60px", marginTop: "80px", marginBottom: "80px" }} >
                    </Spinner>


                </div>

            </>
        );
    }

    render() {
        // if (!this.state.teamFetched) {
        //     return this.props.spinner;
        // }

        // let start = this.settings.itemsPerPage * (this.state.activePage - 1);
        // let end = start + this.settings.itemsPerPage;


        return (
            <section className="sssArea my-3">
                <div className="container">
                    <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <ul className="fgaBreadcrumb">
                                <li>
                                    <a href="/" style={{ verticalAlign: "middle" }}>
                                        <span className="iconmford fo-icon-home"></span>
                                    </a>

                                </li>
                                <li>
                                    <a href="#" style={{ verticalAlign: "middle" }}>
                                        <Trans desc="Şirket Bilgileri">10024</Trans>
                                    </a>
                                </li>
                                <li className="active">
                                    <Trans desc="guideTitle">guideTitle</Trans>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
                            <div className="profilBaslik">
                                <Trans desc="guideTitle">guideTitle</Trans>
                            </div>
                        </div>
                    </div>



                    {this.state.isDataLoading ? this.Load() : this.renderKlavuz()}





                    {/* {this.renderTableToolbar()}

                    <div className="row py-4 bottomRow">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <GuideMembersTable
                                data={this.state.filteredTeamData.slice(start, end)}
                            />
                        </div>
                    </div>
                    <div className="row py-4 bottomRow">
                        <div className="col-xs-0 col-sm-0 col-md-9 col-lg-9"></div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                            {this.renderPager()}
                        </div>
                    </div> */}




                </div>
            </section>
        );
    }
}


// export default connect(null, null)(
//     containsLongRunningProcess(GuideCenter)
// );


export default connect(null, null)(requireAuth(containsLongRunningProcess(GuideCenter)));